import { Typography } from "@circle-react-uikit/Typography";
import { useSmScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { IconButton } from "@circleco/compass/components/IconButton";

import { t } from "@/i18n-js/instance";

interface EmailDisplayBoxProps {
  email: string;
  onClose: () => void;
}

export const EmailDisplayBox = ({ email, onClose }: EmailDisplayBoxProps) => {
  const isSmScreen = useSmScreenMediaQuery();

  return (
    <div className="bg-secondary flex items-center justify-between rounded-t-lg py-[13px]">
      <Typography.BodySm weight="normal" size="text-md">
        {email}
      </Typography.BodySm>
      <IconButton
        aria-label={t("close")}
        variant="ghost"
        onClick={onClose}
        icon="cross"
        size={isSmScreen ? "sm" : "md"}
      />
    </div>
  );
};
